import { Input } from "@/components/ui/input"
import type { AvailabilityRule } from "@/types"
import { defaultPausaTimes } from "../pages/Hours/hoursPausa"

export const DAYS = [
  { value: 0, label: "Domingo" },
  { value: 1, label: "Lunes" },
  { value: 2, label: "Martes" },
  { value: 3, label: "Miércoles" },
  { value: 4, label: "Jueves" },
  { value: 5, label: "Viernes" },
  { value: 6, label: "Sábado" },
]

export function HoursDayList({
  availability,
  onChange,
  disabled = false,
  compact = false,
}: {
  availability: AvailabilityRule[]
  onChange: (next: AvailabilityRule[]) => void
  disabled?: boolean
  compact?: boolean
}) {
  const patch = (dayIndex: number, fields: Partial<AvailabilityRule>) => {
    onChange(
      availability.map((rule) =>
        rule.day_of_week === dayIndex ? { ...rule, ...fields } : rule,
      ),
    )
  }

  const inputClass = compact ? "w-[7rem] h-8 text-sm" : "w-[7.5rem]"

  return (
    <div className="divide-y divide-border">
      {DAYS.map((day) => {
        const rule = availability.find((item) => item.day_of_week === day.value)
        if (!rule) return null

        return (
          <div
            key={day.value}
            className={`flex flex-wrap items-center gap-x-4 gap-y-2 ${compact ? "px-3 py-2" : "p-4"}`}
          >
            <div className={compact ? "w-24" : "w-28"}>
              <label className={`flex items-center gap-2 ${compact ? "text-sm" : ""}`}>
                <input
                  type="checkbox"
                  className="h-4 w-4 rounded border-input"
                  checked={Boolean(rule.enabled)}
                  onChange={() => patch(day.value, { enabled: !rule.enabled })}
                  disabled={disabled}
                />
                <span
                  className={
                    rule.enabled ? "font-medium" : "text-muted-foreground"
                  }
                >
                  {day.label}
                </span>
              </label>
            </div>

            {rule.enabled ? (
              <div className="flex min-w-0 flex-1 flex-col gap-2">
                <div className="flex flex-wrap items-center gap-2">
                  <Input
                    type="time"
                    step={900}
                    className={inputClass}
                    value={rule.start_time}
                    onChange={(e) =>
                      patch(day.value, { start_time: e.target.value })
                    }
                    disabled={disabled}
                  />
                  <span className="text-muted-foreground">a</span>
                  <Input
                    type="time"
                    step={900}
                    className={inputClass}
                    value={rule.end_time}
                    onChange={(e) =>
                      patch(day.value, { end_time: e.target.value })
                    }
                    disabled={disabled}
                  />
                  <label className="ml-1 flex items-center gap-2 text-sm">
                    <input
                      type="checkbox"
                      className="h-4 w-4 rounded border-input"
                      checked={Boolean(rule.pausa_enabled)}
                      disabled={disabled}
                      onChange={() => {
                        if (rule.pausa_enabled) {
                          patch(day.value, { pausa_enabled: false })
                          return
                        }
                        patch(day.value, {
                          pausa_enabled: true,
                          ...defaultPausaTimes(rule.start_time, rule.end_time),
                        })
                      }}
                    />
                    Pausa
                  </label>
                </div>
                {rule.pausa_enabled && (
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-sm text-muted-foreground">De</span>
                    <Input
                      type="time"
                      step={900}
                      className={inputClass}
                      value={rule.pausa_start_time || "14:00"}
                      onChange={(e) =>
                        patch(day.value, { pausa_start_time: e.target.value })
                      }
                      disabled={disabled}
                    />
                    <span className="text-muted-foreground">a</span>
                    <Input
                      type="time"
                      step={900}
                      className={inputClass}
                      value={rule.pausa_end_time || "15:00"}
                      onChange={(e) =>
                        patch(day.value, { pausa_end_time: e.target.value })
                      }
                      disabled={disabled}
                    />
                    <span className="text-xs text-muted-foreground">
                      La sucursal no atiende en ese horario.
                    </span>
                  </div>
                )}
              </div>
            ) : (
              <span className="text-sm text-muted-foreground">Cerrado</span>
            )}
          </div>
        )
      })}
    </div>
  )
}
